import { isDate } from 'ngx-bootstrap/chronos';
import { GridQuery } from './grid-query.model';

export interface GridRequestQuery {
  filters: GridRequestFilter[];
  sorts: GridRequestSorting[];
  page: number;
  pageSize: number;
}

export interface GridRequestFilter {
  columnNames: string[];
  operator: GridFilterOperator;
  values: string[] | number[] | Date[];
}

export interface GridRequestSorting {
  columnName: string;
  descending: boolean;
}

export enum GridFilterOperator {
  Equals = 0,
  Contains,
  GreaterThan,
  LessThan,
  GreaterThanOrEqualTo,
  LessThanOrEqualTo,
  NotEqual
}

export const gridQueryToRequestQuery = (
  { filters, sortBy, descending, pageSize, pageNumber }: GridQuery,
  operatorsMap: { [key: string]: GridFilterOperator } = {},
  columnNamesMap: { [key: string]: string } = {}
): GridRequestQuery => {
  return {
    filters: Object.keys(filters).reduce((acc, key) => {
      if (filters[key].length === 2 && isDate(filters[key][0])) {
        acc.push({
          columnNames: [columnNamesMap[key] || key],
          operator: GridFilterOperator.GreaterThanOrEqualTo,
          values: [filters[key][0]]
        });
        acc.push({
          columnNames: [columnNamesMap[key] || key],
          operator: GridFilterOperator.LessThanOrEqualTo,
          values: [filters[key][1]]
        });
      } else {
        acc.push({
          columnNames: [columnNamesMap[key] || key],
          operator: operatorsMap[key] || GridFilterOperator.Equals,
          values: filters[key]
        });
      }
      return acc;
    }, []),
    sorts: sortBy
      ? [
          {
            columnName: sortBy,
            descending
          }
        ]
      : [],
    page: pageNumber,
    pageSize
  };
};
